import React from 'react';
import { Link } from 'react-router-dom';
import { SunIcon, MoonIcon } from '@heroicons/react/24/solid';

const Header = ({ theme, setTheme }) => {
  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };
  return (
    <header className="bg-primary-700 text-white shadow-md">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center">
          <h1 className="text-2xl font-bold">ProvocaBot</h1>
        </div>
        <nav className="flex items-center">
          <ul className="flex space-x-4">
            <li>
              <Link to="/" className="hover:text-primary-200 transition-colors">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-primary-200 transition-colors">
                About
              </Link>
            </li>
          </ul>
          <button
            onClick={toggleTheme}
            className="ml-4 p-2 rounded-full text-primary-200 hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-primary-700 focus:ring-white"
          >
            {theme === 'light' ? (
              <MoonIcon className="h-6 w-6" />
            ) : (
              <SunIcon className="h-6 w-6" />
            )}
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
